import { useState } from 'react';
import '../styles/pages/Contact.scss';
import { MdMailOutline } from "react-icons/md";
import { LuPhone } from "react-icons/lu";
import { GrLocation } from "react-icons/gr";
import { SlSocialFacebook } from "react-icons/sl";
import { PiInstagramLogoLight } from "react-icons/pi";
import { SlSocialLinkedin } from "react-icons/sl";
import { FaWhatsapp } from "react-icons/fa";
import { useTranslation } from 'react-i18next';
import emailjs from '@emailjs/browser';

const Contact = () => {
    const { t } = useTranslation();
    const [name, setName] = useState('');
    const [email, setEmail] = useState('');
    const [phone, setPhone] = useState('');
    const [adresse, setAdresse] = useState('');
    const [message, setMessage] = useState('');
    const [isSubmitting, setIsSubmitting] = useState(false);
    const [submitStatus, setSubmitStatus] = useState('');

    const handleSubmit = async (e) => {
        e.preventDefault();
        setIsSubmitting(true);
        setSubmitStatus('');

        // Récupérer les configurations depuis les variables d'environnement
        const sheetDBUrl = process.env.REACT_APP_SHEETDB_API_URL;
        const emailJsServiceId = process.env.REACT_APP_EMAILJS_SERVICE_ID;
        const emailJsTemplateId = process.env.REACT_APP_EMAILJS_TEMPLATE_ID;
        const emailJsPublicKey = process.env.REACT_APP_EMAILJS_PUBLIC_KEY;

        // Vérifier que les URLs sont configurées
        if (!sheetDBUrl || sheetDBUrl === 'your_sheetdb_api_url_here') {
            console.error('SheetDB API URL manquante. Vérifiez votre fichier .env');
            alert('Erreur de configuration SheetDB. Veuillez vérifier la configuration.');
            setSubmitStatus('error');
            setIsSubmitting(false);
            return;
        }

        if (!emailJsServiceId || !emailJsTemplateId || !emailJsPublicKey) {
            console.error('EmailJS configuration manquante. Vérifiez votre fichier .env');
            alert('Erreur de configuration EmailJS. Veuillez vérifier la configuration.');
            setSubmitStatus('error');
            setIsSubmitting(false);
            return;
        }

        // Préparer les données
        const currentDate = new Date().toLocaleString('fr-FR', {
            day: '2-digit',
            month: '2-digit',
            year: 'numeric',
            hour: '2-digit',
            minute: '2-digit'
        });

        const formData = {
            data: {
                Date: currentDate,
                Nom: name,
                Email: email,
                Téléphone: phone,
                Adresse: adresse,
                Message: message
            }
        };

        // Préparer les données pour EmailJS
        const emailParams = {
            from_name: name,
            from_email: email,
            phone: phone,
            address: adresse,
            message: message,
            date: currentDate
        };

        console.log('=== Envoi des données ===');
        console.log('Date:', currentDate);
        console.log('Nom:', name);
        console.log('Email:', email);
        console.log('Téléphone:', phone);
        console.log('Adresse:', adresse);
        console.log('Message:', message);
        console.log('========================');

        try {
            // 1. Envoyer les données à SheetDB (Google Sheets)
            const sheetResponse = await fetch(sheetDBUrl, {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                },
                body: JSON.stringify(formData)
            });

            if (!sheetResponse.ok) {
                throw new Error(`Erreur SheetDB: ${sheetResponse.status}`);
            }

            const sheetResult = await sheetResponse.json();
            console.log('✓ Données enregistrées dans Google Sheets!', sheetResult);

            // 2. Envoyer l'email via EmailJS
            const emailResponse = await emailjs.send(
                emailJsServiceId,
                emailJsTemplateId,
                emailParams,
                emailJsPublicKey
            );

            console.log('✓ Email envoyé avec succès!', emailResponse);

            // Succès complet
            setSubmitStatus('success');
            
            // Réinitialiser le formulaire
            setName('');
            setEmail('');
            setPhone('');
            setAdresse('');
            setMessage('');
            
            // Effacer le message de succès après 5 secondes
            setTimeout(() => setSubmitStatus(''), 5000);

        } catch (error) {
            console.error('Erreur lors de l\'envoi:', error);
            setSubmitStatus('error');
        } finally {
            setIsSubmitting(false);
        }
    }

    return(
        <div className="main-container">
            <div className='contact-header'>
                <h1> {t('contact.title')} <span className='colored'>{t('contact.colored')}</span> </h1>
            </div>
            <div className="contact-main">
                <form className="contact-form" onSubmit={handleSubmit}>
                    <input 
                        type='text' 
                        placeholder={t('contact.form.name')} 
                        value={name}
                        onChange={(e) => setName(e.target.value)} 
                        required 
                    />
                    <input 
                        type='email' 
                        placeholder={t('contact.form.email')} 
                        value={email}
                        onChange={(e) => setEmail(e.target.value)} 
                        required 
                    />
                    <input 
                        type='tel' 
                        placeholder={t('contact.form.phone')} 
                        value={phone}
                        onChange={(e) => setPhone(e.target.value)} 
                        required 
                    />
                    <input 
                        type='text' 
                        placeholder={t('contact.form.address')} 
                        value={adresse}
                        onChange={(e) => setAdresse(e.target.value)} 
                        required 
                    />
                    <textarea 
                        placeholder={t('contact.form.needs')} 
                        value={message}
                        onChange={(e) => setMessage(e.target.value)} 
                        rows="5"
                        required
                    ></textarea>
                    <button type='submit' disabled={isSubmitting}>
                        {isSubmitting ? t('contact.form.sending') : t('contact.form.submit')}
                    </button>
                    {submitStatus === 'success' && (
                        <div className='submit-message success'>
                            {t('contact.form.success')}
                        </div>
                    )}
                    {submitStatus === 'error' && (
                        <div className='submit-message error'>
                            {t('contact.form.error')}
                        </div>
                    )}
                </form>
                <div className="contact-info">
                    <h2> {t('contact.info.title')} </h2>
                    <div className='info-element'> <MdMailOutline /> <span>contact@2scomptapro.com </span> </div>
                    <div className='info-element'> <LuPhone /> <span>+216 20 372 623</span> </div>
                    <div className='info-element'> <GrLocation /> <span> 52 Avenue Othman Ibn Affan, Menzah 8, 2037 Ariana</span> </div>
                    <h3> {t('contact.info.findUs')} </h3>
                    <div className='social-media'>

                        <a href='https://www.facebook.com/2Sfirms/' target='_blank' rel="noreferrer">
                            <SlSocialFacebook />
                        </a>
                        <a href='https://www.instagram.com/comptapro77/' target='_blank' rel="noreferrer">
                            <PiInstagramLogoLight />
                        </a>
                        <a href='https://www.linkedin.com/company/2s-comptapro' target='_blank' rel="noreferrer">
                            <SlSocialLinkedin />
                        </a>
                                                <a href='https://wa.me/21620372623' target='_blank' rel="noreferrer">
                            <FaWhatsapp />
                        </a>
                    </div>
                </div>
            </div>
            <div className="contact-map-section">
                <h2> {t('contact.map.title')} <span className='colored'>{t('contact.map.colored')}</span> </h2>
                <div className="contact-map">
                    <iframe 
                        src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3192.2891234567!2d10.1683068!3d36.8559708!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x12fd335675bf2395%3A0xe36c0016ea71e922!2s52%20Av.%20Othman%20Ibn%20Affane%2C%20Ariana!5e0!3m2!1sfr!2stn!4v1234567890123!5m2!1sfr!2stn"
                        width="100%"
                        height="100%"
                        style={{ border: 0 }}
                        allowFullScreen=""
                        loading="lazy"
                        referrerPolicy="no-referrer-when-downgrade"
                        title="Localisation 2S Consulting"
                    ></iframe>
                </div>
            </div>
        </div>
    )
}

export default Contact;
